// removed by extract-text-webpack-plugin
module.exports = {"tabs":"_29DuSBPSLKpu1vWczXa1v4","tabNav":"_3sWJz5dtgJvm2tVo5P0rrK"};